import { IUCISModel } from "../../Interfaces/interface";
import { reportRawEvent } from "./RawEventLogger";

export function logUCMetrics(eventName: string, ucisData: IUCISModel, eventCode = "200", eventMessage = "Success", callStack = "") {
    let consentAccepted = {
        content: {
            AccountType: "MSA",
            AppId: ucisData.ClientId,
            AppName: ucisData.AppName,
            AppVersion: "",
            CallStack: callStack,
            ConsentLanguage: ucisData.Market,
            ConsentSurface: ucisData.ConsentSurface,
            ConsentType: ucisData.ConsentType,
            CorrelationId: ucisData.CorrelationId,
            DeviceId: ucisData.DeviceId,
            EventCode: eventCode,
            EventMessage: eventMessage,
            EventName: eventName,
            FormFactor: ucisData.FormFactor,
            ModelId: ucisData.NoticeId,
            ModelType: ucisData.ModelType,
            ModelVersion: ucisData.ModelVersion,
            OS: ucisData.Platform,
            OSVersion: "",
            Platform: ucisData.Platform,
            ReConsentReason: "",
            Region: ucisData.CountryRegion,
            UserId: ucisData.UserId,
        },
        name: eventName
    };

    reportRawEvent(consentAccepted);
}
